let apJSLoadFlag = {};

function apJSLoading() {
    // var ap = tool.Global.currentAP;

    // initJSFun('rtsd'); //对于开发平台来说，每次都要初始化rtsd
    // initJSFun('wos'); //初始化wos
    // initJSFun('opportunity'); //初始化商机
    // initJSFun('batch'); //初始化批处理
    // initJSFun('program'); //初始化方案
    // initJSFun('statistics'); //初始化统计
    // initJSFun('param'); //初始化参数
    // initJSFun('rtuam'); //初始化rtuam

    // initJSFun2tool("wmp"); //初始化wmp全局方法，放入tool.fun[ap]中

    let others = sgiConfig.jsFunAps || [];
    others.forEach(ap => {
        initJSFun(ap);
    });
}

function initJSFun(ap) {

    if (apJSLoadFlag[ap]) {
        return;
    } else {
        apJSLoadFlag[ap] = true;
    }


    var tt = "GJS";
    var prms = PrmFactory.getPrmByTT(ap, tt);
    if (!prms || prms.length === 0) {
        prms = [];//空列表，不再放入初始化对象
    }

    var initPrms = [];

    window[ap] = window[ap] || {};
    prms.forEach(element => {

        let funanme = element.c;
        let fun = element.jsfun;
        let params = element.params;
        let isInitRun = element.isInitRun;
        let paramsArray = [];
        if (params) {
            paramsArray = params.split(',');
        }
        if (funanme) {
            window[ap][funanme] = new Function(...paramsArray, fun);
            //是否初始化 执行
            if (isInitRun == '1') {
                try {
                    initPrms.push(window[ap][funanme]);
                } catch (error) {
                    tool.sgiLogger.info(error);
                }

            }
        }
    });

    //加载后 执行初始化 执行函数
    initPrms.forEach(element => {
        element();
    });
}

function initJSFun2tool(ap) {

    if (apJSLoadFlag[ap]) {
        return;
    } else {
        apJSLoadFlag[ap] = true;
    }


    var tt = "GJS";
    var prms = PrmFactory.getPrmByTT(ap, tt);
    if (!prms || prms.length === 0) {
        prms = [];//空列表，不再放入初始化对象
    }

    if (!tool) {
        tool.sgiLogger.error(`tool工具尚未初始化！全局方法无法加载！ap=${ap}`);
        apJSLoadFlag[ap] = false;
        return;
    }

    // window[ap] = window[ap] || {};
    tool.fun = tool.fun || {};
    tool.fun[ap] = tool.fun[ap] || {};
    prms.forEach(element => {

        let funanme = element.c;
        let fun = element.jsfun;
        let params = element.params;
        let paramsArray = [];
        if (params) {
            paramsArray = params.split(',');
        }
        if (funanme) {
            tool.fun[ap][funanme] = new Function(...paramsArray, fun);
        }
    });
}

export { apJSLoading }


// WEBPACK FOOTER //
// ./apps/project/appInit.js